const e=(e,n,t)=>{const{kind:s,elements:i}=n;return{kind:s,elements:i,finisher(n){t(e,n)}}},n=(e,n,t)=>(t(e,n),n);export{n as classLegacyDecorator,e as classStandardDecorator};
